import type { VhAdminUser } from '@/admin/admin.types';

export const roleLabel = (role: string) =>
  role.replace('-', ' ').replace(/^./, (c) => c.toUpperCase());

export const initials = (firstName: string, lastName: string) =>
  `${firstName?.[0] ?? ''}${lastName?.[0] ?? ''}`.toUpperCase() || '?';

export const userRoles = (user: VhAdminUser) => [
  ...new Set(user.services?.map((s) => s.role) ?? []),
];

export const userContact = (user: VhAdminUser, type: 'email' | 'phone') =>
  user.contacts?.find((c) => c.contact_type === type)?.contact;

/** "on_board" -> "On board". */
export const humanize = (value: string) =>
  value.replaceAll('_', ' ').replace(/^./, (c) => c.toUpperCase());

export const formatDate = (value?: string) =>
  value
    ? new Date(value).toLocaleDateString(undefined, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      })
    : '-';
